import {BaseObject} from './BaseObject';
import {DocumentCompany} from './DocumentCompany';
import {DocumentType} from './DocumentType';
import {DocumentCompanyAccount} from './DocumentCompanyAccount';
import {Customer} from './Customer';
import {PaymentTypeEntity} from './PaymentType';
import {Product} from './Product';
import {Vat} from './Vat';
import {ContractState} from './ContractState';

export class DocumentItem extends BaseObject {

    id: number;
    product: Product = null;
    vat: Vat;
    itemType: string = 'product'; // product / text / rounding
    text: string = '';
    unitPrice: number = 0;
    count: number = 1;
    fake: boolean = false;
    discount: number = 0;
    position: number = 1;
    with_vat: boolean = false;


    getPrice = (withVat = false): number => {
        let price = this.unitPrice * this.count;
        price = price - (price * (this.discount / 100));
        if (withVat) {
            price = price + (price * (this.vat.rate / 100));
        }
        return price;
    }
}



// WEBPACK FOOTER //
// /app/src/model/Entities/DocumentItem.ts